export const SettingsRoutes = {
  INDEX: "/settings",
  USERS: "/settings/users",
  ROLES: "/settings/roles",
} as const;
